import React, { useEffect, useState } from "react";
import { ButtonGroup, Col, Form, Label, Row, FormGroup, Input } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";

import SelectCustom from "components/Common/SelectCustom";
import { getAreas } from "store/Config/actions";
import { actionGetTypePropertiesSelect, getTypeProperties } from "store/CatTypeProperties/actions";
import { getReportProperties, getReportPropertiesDiscontinued } from "store/Reports/actions";

const FormReportConf = (props) => {

    const dispatch = useDispatch();
    const { typePropertiesLevel3, areas } = useSelector(state => ({
        typePropertiesLevel3: state.TypePropertyReducer.typePropertiesLevel3,
        areas: state.ConfigInit.areas,
    }));

    const [reportType, setReportType] = useState("general");

    useEffect(() => {
        dispatch(actionGetTypePropertiesSelect({ active: true, typePropertyParent: null, getLevel3:true }));
        dispatch(getAreas({ for_: 'inventory', active: true }));
    }, []);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            area: "",
            typeProperty: "",
            reportType: "general",
        },
        validationSchema: Yup.object({
            area: Yup.string().when('reportType', {
                is: 'area',
                then: Yup.string().required("Selecciona el area para generar el reporte"),
                otherwise: Yup.string(),
            }),
            typeProperty: Yup.string().when('reportType', {
                is: 'typeProperty',
                then: Yup.string().required("Selecciona el tipo de bien para generar el reporte"),
                otherwise: Yup.string(),
            }),
        }),
        onSubmit: (values) => {
            const report = {
                reportType: values.reportType,
            };
            
            if (values.reportType === "area" && values.area) {
                report.area_id = values.area;
            } else if (values.reportType === "typeProperty" && values.typeProperty) {
                report.typeProperty_id = values.typeProperty;
            } else if(values.reportType === "discontinuedTransport" && values.discontinuedTransport) {
                report.discontinuedTransport = values.discontinuedTransport;
            } else if(values.reportType === "discontinuedOthers" || values.reportType === "discontinuedTransport") {
                report.discontinuedOthers = values.discontinuedOthers;
            }
            if(values.reportType === "discontinuedOthers" || values.reportType === "discontinuedTransport") {
                dispatch(getReportPropertiesDiscontinued(report));
            } else {
                dispatch(getReportProperties(report));
            }
        }
    });

    const handleReportTypeChange = (e) => {
        setReportType(e.target.value);
        validation.setFieldValue("reportType", e.target.value);
    };

    return (
        <>
            <Form onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
            }}>
                <Row className="mb-3">
                    <Col md={12}>
                        <FormGroup tag="fieldset">
                            <legend className="col-form-label font-weight-bold">Elige filtro:</legend>
                            <FormGroup check inline>
                                <Input
                                    type="radio"
                                    name="reportType"
                                    id="reportGeneral"
                                    value="general"
                                    checked={reportType === "general"}
                                    onClick={handleReportTypeChange}
                                />
                                <Label check for="reportGeneral">Reporte general</Label>
                            </FormGroup>
                            <FormGroup check inline>
                                <Input
                                    type="radio"
                                    name="reportType"
                                    id="reportTypeProperty"
                                    value="typeProperty"
                                    checked={reportType === "typeProperty"}
                                    onClick={handleReportTypeChange}
                                />
                                <Label check for="reportTypeProperty">Por tipo de bien</Label>
                            </FormGroup>
                            <FormGroup check inline>
                                <Input
                                    type="radio"
                                    name="reportType"
                                    id="reportArea"
                                    value="area"
                                    checked={reportType === "area"}
                                    onClick={handleReportTypeChange}
                                />
                                <Label check for="reportArea">Por área</Label>
                            </FormGroup>
                            <FormGroup check inline>
                                <Input
                                    type="radio"
                                    name="reportType"
                                    id="discontinuedTransport"
                                    value="discontinuedTransport"
                                    checked={reportType === "discontinuedTransport"}
                                    onClick={handleReportTypeChange}
                                />
                                <Label check for="discontinuedTransport">Baja en Transporte o Vehículos</Label>
                            </FormGroup>
                            <FormGroup check inline>
                                <Input
                                    type="radio"
                                    name="reportType"
                                    id="reportDiscontinuedOthers"
                                    value="discontinuedOthers"
                                    checked={reportType === "discontinuedOthers"}
                                    onClick={handleReportTypeChange}
                                />
                                <Label check for="reportDiscontinuedOthers">Baja Otros bienes</Label>
                            </FormGroup>
                        </FormGroup>
                    </Col>
                </Row>
                
                <Row>
                    {reportType === "area" && (
                        <Col className="col-6">
                            <ButtonGroup>
                                <SelectCustom
                                    lblInput="Selecciona el área para generar el reporte"
                                    inputName="area"
                                    inputPlaceholder="Elige el área"
                                    validation={validation}
                                    data={areas}
                                />
                            </ButtonGroup>
                        </Col>
                    )}
                    
                    {reportType === "typeProperty" && (
                        <Col className="col-6">
                            <ButtonGroup>
                                <SelectCustom
                                    lblInput="Selecciona el tipo de bien para generar el reporte"
                                    inputName="typeProperty"
                                    inputPlaceholder="Elige el tipo de bien"
                                    validation={validation}
                                    data={typePropertiesLevel3}
                                />
                            </ButtonGroup>
                        </Col>
                    )}
                    
                    <Col className="col-6">
                        <Label className="form-label">&nbsp;</Label>
                        <div className="">
                            <button
                                type="submit"
                                className="btn btn-success save-schedule"
                            >
                                Enviar
                            </button>
                        </div>
                    </Col>
                </Row>
            </Form>
        </>
    )
}

export default FormReportConf